import { IUser } from "@imaginelearning/mps-api-service";

/**
 * Builds the launch URL for the Earlybird assessment.
 * @param testNumber - The test number used to determine the time period for the assessment
 * @param user - The user object containing organization and academic session information
 * @returns A fully constructed URL string for launching the assessment with authentication parameters
 * @example
 * const url = buildLaunchUrl(1, userObject);
 * // Returns: "https://baseurl/#/auth?retake=false&academicYear=2023&authType=IMLP&timePeriod=FALL"
 */
export default function buildLaunchUrl(testNumber: number, user: IUser, retake: boolean): string {
  const baseUrl = window.STUDENT_ENV.REACT_APP_EARLYBIRD_LAUNCH_URL;
  const academicYear = user?.organization?.academicSession?.schoolYear ?? 0;
  const timePeriod = getTimePeriod(testNumber);
  return `${baseUrl}/#/auth?retake=${!!retake}&academicYear=${academicYear}&authType=IMLP&timePeriod=${timePeriod}`;
}

function getTimePeriod(testNumber: number) {
  if (testNumber === 2) {
    return "MOY";
  }
  if (testNumber < 2) {
    return "BOY";
  }

  return "EOY";
}
